import {MessageBox, Message} from 'element-ui'

export default {
    alert(message, title, options) {
        return MessageBox.alert(message, title, options)
    },
    confirm(message, title, options) {
        return MessageBox.confirm(message, title, options)
    },
    message(message, type) {
        return Message({
            message: message,
            type: type
        })
    }
}


// WEBPACK FOOTER //
// ./src/commons/Tips.js